var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", { staticClass: "page", attrs: { role: "main" } }, [
    _c("div", { staticClass: "c-search" }, [
      _c("div", { staticClass: "o-wrapper" }, [
        _c("div", { staticClass: "o-grid o-grid--center" }, [
          _c(
            "div",
            {
              staticClass:
                "c-search__search o-grid__item u-width-10/12 u-width-full@m",
            },
            [
              _c("input", {
                ref: "searchCommunities",
                staticClass: "c-textbox c-textbox--communities",
                attrs: { type: "text", placeholder: "Search All Communities" },
                domProps: { value: _vm.search },
                on: {
                  input: (ev) => (_vm.search = ev.target.value),
                  keyup: (event) => _vm.getInput(event),
                },
              }),
              _vm._v(" "),
              _vm.showReset && !_vm.showLoader
                ? _c("img", {
                    staticClass: "c-community__clear-search active",
                    attrs: {
                      src: _vm.$cdn("/img/ui/icon-close-black-large.svg"),
                      alt: "reset text",
                      width: "31",
                      height: "30",
                    },
                    on: { click: _vm.clearInput },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showLoader
                ? _c("img", {
                    staticClass: "loader",
                    attrs: {
                      src: _vm.$cdn("/img/ui/icon-loader-eclipse.svg"),
                      alt: "loading",
                      width: "40",
                      height: "40",
                    },
                  })
                : _vm._e(),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-communities__tiles u-m-t5" }, [
      _c("div", { staticClass: "o-wrapper" }, [
        _c("div", { staticClass: "o-grid o-grid--center" }, [
          _c(
            "div",
            { staticClass: "o-grid__item u-width-10/12 u-width-full@l" },
            [
              _c(
                "div",
                { staticClass: "c-communities__wrapper u-p-b2 u-m-b5" },
                _vm._l(_vm.communities, function (item, index) {
                  return _c("div", { staticClass: "c-communities__tile" }, [
                    _c("a", { attrs: { href: "/" + item.url } }, [
                      _c("img", {
                        staticClass: "c-communities__img u-m-r1@s",
                        attrs: {
                          src: _vm.$simpleStore.transformImageWithCloudfront(
                            180,
                            180,
                            item.community_pic,
                            _vm.$root
                          ),
                          width: "180",
                          height: "180",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "c-communities__name" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                    ]),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _vm.showSuggest
                ? _c("div", { staticClass: "c-panel__community-noresults" }, [
                    _c("div", [
                      _vm.communities.length === 0
                        ? _c("p", { staticClass: "u-color-text u-bold" }, [
                            _vm._v("No community found"),
                          ])
                        : _c("p", { staticClass: "u-color-text u-bold" }, [
                            _vm._v("No more communities found"),
                          ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "u-color-grey2 u-text-small" }, [
                        _vm._v(
                          "Can't find the community you are looking for? Why not suggest a community?"
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("button", {
                        staticClass: "c-panel__community-new",
                        on: {
                          click: function ($event) {
                            return _vm.$simpleStore.suggest(
                              _vm.$router,
                              "Search Community"
                            )
                          },
                        },
                      }),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.$root.user !== false
      ? _c("a", {
          staticClass: "c-article__add",
          attrs: { href: "/post/create/" },
        })
      : _c("a", { staticClass: "c-article__add js-join-convo__cta" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }